function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9,
    rx: 8.49,
    ry: 8.13,
    style: {
      fill: "#5fb258"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14.01 6.43 7.44 12.57 4.86 10.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "2.04415154457092px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGreen);
export default __webpack_public_path__ + "static/media/checkbox_green.506439cfc31669e0a93b192bf8898f61.svg";
export { ForwardRef as ReactComponent };